const REFERRAL_COOKIE = "ts_other_store_ref";
const REFERRAL_COOKIE_DAYS = 400;

function readCookie(name) {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : "";
}

function writeCookie(name, value, maxAgeDays) {
  const maxAge = Math.max(1, maxAgeDays) * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function getStoredReferral() {
  try {
    const raw = readCookie(REFERRAL_COOKIE);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.code) {
      return null;
    }
    return {
      code: String(parsed.code),
      visitedAt: parsed.visitedAt || new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

export function storeReferral(code, visitedAt) {
  if (!code) {
    return null;
  }
  const payload = {
    code: String(code).trim().toLowerCase(),
    visitedAt: visitedAt || new Date().toISOString(),
  };
  writeCookie(REFERRAL_COOKIE, JSON.stringify(payload), REFERRAL_COOKIE_DAYS);
  return payload;
}

export function getReferralPayloadForCheckout() {
  const stored = getStoredReferral();
  if (!stored) {
    return {};
  }
  return {
    refCode: stored.code,
    refVisitedAt: stored.visitedAt,
  };
}
